import request from '@/utils/request'

export function getDict() {
  return request({
    url: 'basic/sissdictitem/get/list',
    method: 'GET'
  })
}

export function getAllRegion() {
  return request({
    url: 'basic/sissarea/all',
    method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/dict.js